"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RectangleInfoLoading = exports.RectangleInfo = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const colors_1 = require("../../../../../assets/styles/colors");
const mapParamsHandler_1 = require("../../../../../utils/mapParamsHandler");
const RectangleInfo_style_1 = require("./RectangleInfo.style");
const RectangleInfo = ({ color, rectangleData }) => {
    const { unitSymbol } = (0, mapParamsHandler_1.useMapParams)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const { average, numberOfSamples, numberOfContributors } = rectangleData;
    return (react_1.default.createElement(RectangleInfo_style_1.RectangleInfoContainer, null,
        react_1.default.createElement(RectangleInfo_style_1.DataContainer, { "$color": color },
            react_1.default.createElement(RectangleInfo_style_1.RectangleInfoHeader, null,
                react_1.default.createElement(RectangleInfo_style_1.RectangleCircle, { "$color": color }),
                react_1.default.createElement(RectangleInfo_style_1.RectangleInfoBoldText, null, `${t("map.rectangleInfo.average")} ${average.toFixed(0)} ${unitSymbol} `)),
            react_1.default.createElement(RectangleInfo_style_1.RectangleInfoText, null,
                numberOfSamples,
                ` ${t("map.rectangleInfo.measurements")}`),
            react_1.default.createElement(RectangleInfo_style_1.RectangleInfoText, null,
                numberOfContributors,
                ` ${t("map.rectangleInfo.contributors")}`))));
};
exports.RectangleInfo = RectangleInfo;
const RectangleInfoLoading = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return (react_1.default.createElement(RectangleInfo_style_1.RectangleInfoContainer, null,
        react_1.default.createElement(RectangleInfo_style_1.DataContainer, { "$color": colors_1.grey, "$loading": true },
            react_1.default.createElement(RectangleInfo_style_1.RectangleInfoHeader, { "$loading": true },
                react_1.default.createElement(RectangleInfo_style_1.RectangleCircle, { "$color": colors_1.grey }),
                react_1.default.createElement(RectangleInfo_style_1.RectangleInfoColorText, { "$color": colors_1.grey }, `${t("map.rectangleInfo.loading")}`)))));
};
exports.RectangleInfoLoading = RectangleInfoLoading;
